import { Component } from 'react';
import styled from 'styled-components';
import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import { SC_DARK_PINK, SC_GRAY } from '../themes/DefaultTheme';

const SelectableCardElement = styled.div`
  border: ${(props: any) => '1px solid ' + props.theme.vars.newColor.lightGS1};
  padding: 30px;
  border-radius: 10px;
  background-color: white;
  margin-bottom: 10px;
` as any;

const IconElement = styled.div`
  font-size: 25px;
  margin-bottom: 20px;
`;

const HeadingElement = styled.h1`
  color: ${(props: any) => (props.isSelected ? props.theme.vars.color.pink : props.theme.vars.newColor.darkGS1)};
  font-size: 16px;
  font-weight: 600;
  margin: 0px;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
` as any;

const SubHeadingElement = styled.h2`
  font-size: 16px;
  margin: 0px;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #8a8a8a;
  margin-bottom: 10px;
`;

const DescriptionElement = styled.div`
  color: ${(props: any) => props.theme.vars.newColor.darkGS2};
  margin-bottom: 10px;
`;

const ButtonElement = styled(Button)`
  margin-top: 20px;
  width: 100%;
`;

export interface IProps {
  /** The id of the card. */
  id?: string | number;
  /** The card heading text. */
  heading: string;
  /** The card sub-heading text. */
  subHeading?: string;
  /** The card description text. */
  description?: string;
  /** The font-awesome icon name. */
  icon?: string;

  /* True if the card is selected.  Defaults to false. */
  isSelected?: boolean;
  /** Event invoked when select button is clicked. */
  onClick?: (id?: string | number) => void;
}

export class SelectableCard extends Component<IProps> {
  public render() {
    const color = this.props.isSelected ? SC_DARK_PINK : SC_GRAY;
    return (
      <SelectableCardElement data-testid="SelectableCard" isSelected={this.props.isSelected}>
        <IconElement>
          <Icon icon={this.props.icon} size="extra-large" color={color} />
        </IconElement>
        <HeadingElement heading={this.props.heading} isSelected={this.props.isSelected}>
          {this.props.heading}
        </HeadingElement>
        <SubHeadingElement>{this.props.subHeading}</SubHeadingElement>
        <DescriptionElement>{this.props.description}</DescriptionElement>
        <ButtonElement variation={this.props.isSelected ? 'secondary' : 'secondary'} onClick={this.handleButtonClicked}>
          {this.props.isSelected ? 'Selected' : 'Select'}
        </ButtonElement>
      </SelectableCardElement>
    );
  }

  private handleButtonClicked = () => {
    if (this.props.onClick) {
      this.props.onClick(this.props.id);
    }
  };
}
